import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/wxmp',
    children: [
      {
        path: 'agreement',
        name: 'Agreement',
        meta: {
          title: '用户协议',
          keepAlive: true,
        },
        component: () => import('@/views/wxmp/agreement.vue'),
      },
      {
        path: 'privacy',
        name: 'Privacy',
        meta: {
          title: '隐私政策',
          keepAlive: true,
        },
        component: () => import('@/views/wxmp/privacy.vue'),
      },
      {
        path: 'enclosure',
        name: 'Enclosure',
        meta: {
          title: '个人信息',
          keepAlive: true,
        },
        component: () => import('@/views/wxmp/enclosure.vue'),
      },
      {
        path: 'guard',
        name: 'Guard',
        meta: {
          title: '智能守护',
          keepAlive: true,
        },
        component: () => import('@/views/wxmp/guard.vue'),
      },
      {
        path: 'guardserver',
        name: 'Guardserver',
        meta: {
          title: '智能守护',
          keepAlive: true,
        },
        component: () => import('@/views/wxmp/guardserver.vue'),
      },
    ],
  },
]

export default routes
